import type { SVGProps } from 'react';
const DawnFlagMM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-MM_svg__a)">
      <path fill="#F13D4F" d="M0 16h22v-5.333H0z" />
      <path fill="#4AC94B" d="M0 10.667h22V5.333H0z" />
      <path fill="#FFD043" d="M0 5.333h22V0H0z" />
      <path
        fill="#fff"
        d="m11 9.872-2.77 2.011 1.022-3.305-2.735-2.061 3.403-.032L11 3.2l1.081 3.285 3.403.032-2.735 2.061 1.022 3.305z"
      />
    </g>
  </svg>
);
export default DawnFlagMM;
